import { render, staticRenderFns } from "./RefundFlowList.vue?vue&type=template&id=bf25a286&scoped=true"
import script from "./RefundFlowList.vue?vue&type=script&lang=js"
export * from "./RefundFlowList.vue?vue&type=script&lang=js"
import style0 from "./RefundFlowList.vue?vue&type=style&index=0&id=bf25a286&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf25a286",
  null
  
)

export default component.exports